import React from 'react';
import { Link } from 'react-router-dom';
import { FaShoppingCart } from 'react-icons/fa';
import './FloatingCart.css';

const FloatingCart = ({ cartItemsCount }) => {
  if (cartItemsCount === 0) return null;

  return (
    <Link to="/cart" className="floating-cart" aria-label="View cart">
      <FaShoppingCart className="floating-cart-icon" />
      <span className="floating-cart-count">{cartItemsCount}</span>
    </Link>
  );
};

export default FloatingCart;
